import React from "react";
import ServiceCard from "../components/ServiceCard";

export default function ServicesSection() {
  const services = [
    {
      icon: "🤖",
      title: "AI Solutions & Automation",
      description: "AI chatbot development, smart assistants, and workflow automation that cut manual work and save your team hours—built around how your business actually runs.",
      delay: 60
    },
    {
      icon: "💻",
      title: "Web Development",
      description: "Custom website and web application development that loads fast, ranks well on Google, and turns visitors into paying customers.",
      delay: 120
    },
    {
      icon: "📱",
      title: "Mobile App Development",
      description: "Android and iOS app development—native and cross-platform (React Native, Flutter)—with smooth performance and clean, modern design your users love.",
      delay: 180
    },
    {
      icon: "🎮",
      title: "Game Development",
      description: "2D, 3D, and multiplayer game development with real-time systems, backends, and analytics—built to keep players engaged and coming back.",
      delay: 240
    },
    {
      icon: "☁️",
      title: "Cloud & DevOps",
      description: "Cloud setup, hosting, and DevOps on AWS and other platforms—keeping your product fast, secure, and online as your users grow.",
      delay: 300
    },
    {
      icon: "🎨",
      title: "UI/UX Design",
      description: "UI/UX design and prototyping that make your product easy to use and hard to forget—crafted around real user needs to boost conversions.",
      delay: 360
    },
    {
      icon: "💳",
      title: "Payment Integration",
      description: "Secure payment gateway integration with Razorpay, Stripe, and more—subscriptions, checkouts, and refunds set up smoothly for your business.",
      delay: 420
    }
  ];

  return (
    <section className="services" id="services">
      <h2>Our Software Development Services</h2>
      <p className="section-subtitle">
        From AI and web to mobile, cloud, and games—everything you need to build and
        grow your product, all under one team in India
      </p>
      <div className="service-list">
        {services.map((service, i) => (
          <ServiceCard
            key={i}
            icon={service.icon}
            title={service.title}
            description={service.description}
            delay={service.delay}
          />
        ))}
      </div>
    </section>
  );
}
